<template>
    <main-layout>
        <template #breadcrumbs>
            <span class="union-icon">
                <i class="feather-tag"></i>
            </span>
            <span class="repo-chart-title">
                <inertia-link :href="route('home')">
                    <span class="repo-text">Repositories</span>
                </inertia-link>
                <span class="d-line">/ </span>
                <inertia-link :href="route('repository.view', {team: team})">
                    <span class="repo-text">{{ team.slug }}</span>
                </inertia-link>
                <span class="d-line">/ </span>
                Team Members
            </span>
        </template>
        <template #pageTitle>
            <h2 class="mb-1">Members</h2>
            <span class="sm-text"></span>
        </template>
        <team-member-manager
            :team="team"
            :available-roles="availableRoles"
            :user-permissions="permissions"></team-member-manager>
    </main-layout>
</template>

<script>
    import MainLayout from "@/Layouts/MainLayout";
    import TeamMemberManager from "@/Pages/Teams/TeamMemberManager";
    export default {
        name: "RepositoryMembers.vue",
        components: {TeamMemberManager, MainLayout},
        props: ['team', 'availableRoles', 'permissions'],
    }
</script>

<style scoped>

</style>
